/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { ContentAiGenerateAiArticlesContentMutationRequest, ContentAiGenerateAiArticlesContentMutationResponse, ContentAiGenerateAiArticlesContentPathParams, ContentAiGenerateAiArticlesContent401, ContentAiGenerateAiArticlesContent403 } from "../models/ContentAiGenerateAiArticlesContent";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { contentAiGenerateAiArticlesContent } from "../axios/contentAiGenerateAiArticlesContent";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const contentAiGenerateAiArticlesContentMutationKey = () => [{ url: '/content-ai/v1/contents/:id/generate-ai-articles' }] as const

export type ContentAiGenerateAiArticlesContentMutationKey = ReturnType<typeof contentAiGenerateAiArticlesContentMutationKey>

export function contentAiGenerateAiArticlesContentMutationOptions<TContext = unknown>(config: Partial<RequestConfig<ContentAiGenerateAiArticlesContentMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = contentAiGenerateAiArticlesContentMutationKey()
        return mutationOptions<ContentAiGenerateAiArticlesContentMutationResponse, ResponseErrorConfig<ContentAiGenerateAiArticlesContent401 | ContentAiGenerateAiArticlesContent403>, {id: ContentAiGenerateAiArticlesContentPathParams["id"], data: ContentAiGenerateAiArticlesContentMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ id, data }) => {
            return contentAiGenerateAiArticlesContent(id, data, config)
          },
        })

}

/**
 * @summary Generate AI articles from media analysis
 * {@link /content-ai/v1/contents/:id/generate-ai-articles}
 */
export function useContentAiGenerateAiArticlesContent<TContext>(options: 
{
  mutation?: UseMutationOptions<ContentAiGenerateAiArticlesContentMutationResponse, ResponseErrorConfig<ContentAiGenerateAiArticlesContent401 | ContentAiGenerateAiArticlesContent403>, {id: ContentAiGenerateAiArticlesContentPathParams["id"], data: ContentAiGenerateAiArticlesContentMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<ContentAiGenerateAiArticlesContentMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? contentAiGenerateAiArticlesContentMutationKey()

          const baseOptions = contentAiGenerateAiArticlesContentMutationOptions(config) as UseMutationOptions<ContentAiGenerateAiArticlesContentMutationResponse, ResponseErrorConfig<ContentAiGenerateAiArticlesContent401 | ContentAiGenerateAiArticlesContent403>, {id: ContentAiGenerateAiArticlesContentPathParams["id"], data: ContentAiGenerateAiArticlesContentMutationRequest}, TContext>
          

          return useMutation<ContentAiGenerateAiArticlesContentMutationResponse, ResponseErrorConfig<ContentAiGenerateAiArticlesContent401 | ContentAiGenerateAiArticlesContent403>, {id: ContentAiGenerateAiArticlesContentPathParams["id"], data: ContentAiGenerateAiArticlesContentMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ContentAiGenerateAiArticlesContentMutationResponse, ResponseErrorConfig<ContentAiGenerateAiArticlesContent401 | ContentAiGenerateAiArticlesContent403>, {id: ContentAiGenerateAiArticlesContentPathParams["id"], data: ContentAiGenerateAiArticlesContentMutationRequest}, TContext>
      
}